import React from "react";
import { AppConfirmDialog } from "components/common/dialogs";

const DeleteDocumentTypeDialog = ({
  open,
  documentType,
  onClose,
  onConfirm,
  submitting = false,
}) => (
  <AppConfirmDialog
    open={open}
    title="Xác nhận xóa loại tài liệu"
    type="delete"
    message={<>Bạn có chắc chắn muốn xóa loại tài liệu: <strong>{documentType?.Name || documentType?.name || ""}</strong>?</>}
    loading={submitting}
    onClose={onClose}
    onConfirm={onConfirm}
    contentSx={{ overflowWrap: "anywhere" }}
  />
);

export default DeleteDocumentTypeDialog;
